<main class="p-6 overflow-hidden pl-24 h-full max-h-full grid grid-rows-[36px_auto] gap-6">
    <div class="flex justify-between items-center">
        <h1 class="text-shs-white-1 text-3xl font-bold flex items-center gap-1 font-sh-bree">User Management</h1>
        <div class="flex gap-4">
            <sag-ui-button color="primary" size="sm" icon="user" (click)="addUser()">Add User</sag-ui-button>
        </div>
    </div>
    <div class="bg-[#1A1A1A] rounded-md p-6 overflow-hidden">
        <div class="w-full flex flex-col h-full box-border">
            <div class="flex items-center justify-start mb-4">
                <sag-ui-input placeholder="Search ..." class="max-w-[300px] w-full" [formControl]="searchControl">
                    <span
                        ngProjectAs="end-decorator"
                        class="text-[#B3B3B3] pr-4 h-full flex items-center justify-center icon-search"
                    >
                    </span>
                </sag-ui-input>
            </div>
            <div class="grid grid-cols-5 gap-2 border-b border-shs-gray-4 mt-2">
                <div class="text-font-tertiary px-2 py-4 text-xs truncate">GID</div>
                <div class="text-font-tertiary px-2 py-4 text-xs truncate">Name</div>
                <div class="text-font-tertiary px-2 py-4 text-xs truncate">E-Mail</div>
                <div class="text-font-tertiary px-2 py-4 text-xs truncate">Roles</div>
                <div class="text-font-tertiary px-2 py-4 text-xs truncate"></div>
            </div>
            <div class="flex-grow overflow-y-auto overscroll-contain box-content" #table>
                @for (item of users(); track $index) {
                <div class="grid grid-cols-5 gap-2 border-b border-shs-gray-4 cursor-pointer hover:bg-shs-gray-4">
                    <div
                        class="text-font-tertiary px-2 py-4 text-left text-base font-bold truncate flex items-center gap-2"
                    >
                        <span class="w-[2px] h-[80%] inline-block border-l-2 border-shs-orange"></span>
                        {{ item.gid }}
                    </div>
                    <div class="text-font-tertiary px-2 py-4 text-left text-base truncate flex items-center">
                        {{ item.firstName }} {{ item.lastName }}
                    </div>
                    <div class="text-font-tertiary px-2 py-4 text-left text-base truncate flex items-center">
                        {{ item.email }}
                    </div>
                    <div class="text-font-tertiary px-2 py-4 text-left text-base truncate flex items-center">
                        {{ item.roles.join(',') }}
                    </div>
                    <div
                        class="text-font-tertiary px-2 py-4 text-left text-base truncate flex items-center justify-end gap-2"
                    >
                        <sag-ui-button color="primary" size="sm" icon="edit" (click)="editUser(item)"
                            >Edit User</sag-ui-button
                        >
                        <sag-ui-button color="secondary" size="sm" icon="delete" (click)="deleteUser(item)"
                            >Delete</sag-ui-button
                        >
                    </div>
                </div>
                } @if (isLoading()) {
                <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2"></div>
                <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-90"></div>
                <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-80"></div>
                <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-70"></div>
                <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-60"></div>
                <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-50"></div>
                }
            </div>
        </div>
    </div>
</main>
